/**
 * @function createDataLayerEvent
 * @param {object} data Payload that is being sent to the parent webpage.
 * @description Function that emits a dataLayer event that is received by
 *              a handlers in embed.development.js and used to update the data
 *              layer of the parent webpage if one is present.
 */
const createDataLayerEvent = (data = {}) => {
    // Industry standard way to create a data layer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
};

/**
 * @private
 * @function createPurchaseEvent
 * @param {object} data Payload containing event data for the purchase.
 * @description Function that handles different types of purchase events and
 *              triggers the appropriate tracking mechanism (Google Analytics 4 or Meta Pixel).
 *              Logs a warning if the event type is unknown.
 */
const createPurchaseEvent = (data) => {
    if (data.event === "QGIV.ga4Purchase" && window.gtag) {
        window.gtag("event", "purchase", data.ecommerce);
    }
    if (data.event === "QGIV.metaPixelPurchase" && window.fbq) {
        window.fbq("track", "Purchase", data.ecommerce);
    }
};

export { createDataLayerEvent, createPurchaseEvent };
